function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { IntlProvider as ReactIntlProvider } from 'react-intl';
import { Helmet } from 'react-helmet';
var DEFAULT_LOCALE = 'en';
var SUPPORTED_LOCALES = [
    DEFAULT_LOCALE
];
var browserLocale = Array.isArray(navigator.languages) ? navigator.languages[0] : DEFAULT_LOCALE;
var _ref, _ref1;
browserLocale = (_ref1 = (_ref = browserLocale !== null && browserLocale !== void 0 ? browserLocale : navigator.language) !== null && _ref !== void 0 ? _ref : navigator.browserLanguage) !== null && _ref1 !== void 0 ? _ref1 : navigator.userLanguage;
browserLocale = browserLocale.replace('_', '-');
if (!SUPPORTED_LOCALES.includes(browserLocale)) {
    browserLocale = browserLocale.split('-')[0];
}
if (!SUPPORTED_LOCALES.includes(browserLocale)) {
    var _SUPPORTED_LOCALES_find;
    browserLocale = (_SUPPORTED_LOCALES_find = SUPPORTED_LOCALES.find(function(supportedLocale) {
        return supportedLocale.startsWith(browserLocale);
    })) !== null && _SUPPORTED_LOCALES_find !== void 0 ? _SUPPORTED_LOCALES_find : DEFAULT_LOCALE;
}
export function getLocale() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    if (locale == null) {
        locale = browserLocale;
    }
    if (!SUPPORTED_LOCALES.includes(locale)) {
        locale = DEFAULT_LOCALE;
    }
    return locale;
}
export default function IntlProvider(param) {
    var children = param.children;
    // TODO: allow setting locale via store
    var locale = getLocale();
    var _React_useState = _sliced_to_array(React.useState({}), 2), messages = _React_useState[0], setMessages = _React_useState[1];
    React.useEffect(function() {
        if (locale === DEFAULT_LOCALE) {
            return;
        }
        import("./messages/".concat(locale, ".json")).then(function(messages) {
            return setMessages(messages);
        }).catch(function(err) {
            return console.error("encountered an error loading translations for ".concat(locale), err);
        });
    }, [
        locale
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                htmlAttributes: {
                    lang: locale
                }
            }),
            /*#__PURE__*/ _jsx(ReactIntlProvider, {
                messages: messages,
                locale: locale,
                defaultLocale: DEFAULT_LOCALE,
                children: children
            }, "locale-".concat(locale))
        ]
    });
}
